import React, { useCallback, useEffect } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import useInput from "../../hooks/useInput";
import { useAppDispatch } from "../../store";
import { LoginAct } from "../../reduxaction/user";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../reducer/index";

function SignIn() {
  const navigate = useNavigate();
  const { LoginError } = useSelector((state: RootState) => state.user);

  const dispatch = useAppDispatch();

  const [userId, onChangeuserId] = useInput("");
  const [password, onChangePassword] = useInput("");

  const onSubmit = useCallback(
    async (e: any) => {
      try {
        const response = await dispatch(
          LoginAct({
            userId,
            password,
          })
        );
        console.log("response:", response.payload);
        // navigate("/MainPage");
        if (`${userId}!` === password) {
          navigate("/MainPage");
        }
      } catch (error) {
        localStorage.clear();
        console.error(error);
      }
    },

    [userId, password, dispatch, navigate]
  );

  useEffect(() => {
    if (LoginError) {
      // return alert("로그인을 실패하였습니다.");
      return confirmAlert({
        title: "로그인을 실패하였습니다.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
    }
  }, [LoginError]);

  useEffect(() => {
    let accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      navigate("/MainPage");
    } else {
    }
  }, [navigate]);

  return (
    <form className="login-container 12" onSubmit={onSubmit}>
      <div className="login-box">
        <div className="loginstring">
          I.FACTORY
          <span className="loginspan">&nbsp; FARM</span>
        </div>
        <div className="login-form-box">
          <div className="login-form">
            <p>아이디</p>
            <input
              type="userId"
              id="userId"
              name="userId"
              placeholder="아이디"
              value={userId}
              onChange={onChangeuserId}
            />
          </div>
          <div className="login-form">
            <p>비밀번호</p>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="비밀번호"
              value={password}
              onChange={onChangePassword}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  onSubmit(null);
                }
              }}
            />
          </div>
          <div className="login-submit" onClick={onSubmit}>
            로그인
          </div>
        </div>
      </div>
    </form>
  );
}

export default SignIn;
